import React, { useState } from 'react';
import GenomicAnalysis from './GenomicAnalysis';
import GenomicSelection from './GenomicSelection';
import PopulationStructure from './PopulationStructure';

function GenomicAnalysisContainer({ crop }) {
  const [activeTab, setActiveTab] = useState('qc');

  const tabStyle = (tabName) => ({
    flex: 1,
    padding: '15px 20px',
    backgroundColor: activeTab === tabName ? '#025c4f' : '#f5f5f5',
    color: activeTab === tabName ? 'white' : '#333',
    border: 'none',
    borderBottom: activeTab === tabName ? '3px solid #025c4f' : '3px solid transparent',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: activeTab === tabName ? 'bold' : 'normal',
    transition: 'all 0.3s ease'
  });

  return (
    <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
      <div style={{ 
        backgroundColor: 'white', 
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
        {/* Tab Navigation */}
        <div style={{ 
          display: 'flex', 
          borderBottom: '1px solid #ddd',
          backgroundColor: '#f9f9f9'
        }}>
          <button
            onClick={() => setActiveTab('qc')}
            style={tabStyle('qc')}
          >
            🧬 QC Pipeline
          </button>
          <button
            onClick={() => setActiveTab('population')}
            style={tabStyle('population')}
          >
            📊 Population Structure
          </button>
          <button
            onClick={() => setActiveTab('selection')}
            style={tabStyle('selection')}
          >
            🌱 Genomic Selection
          </button>
        </div>

        {/* Tab Content */}
        <div style={{ padding: '0' }}>
          {activeTab === 'qc' && <GenomicAnalysis crop={crop} />}
          {activeTab === 'population' && <PopulationStructure crop={crop} />}
          {activeTab === 'selection' && <GenomicSelection crop={crop} />}
        </div>
      </div>
    </div>
  );
}

export default GenomicAnalysisContainer;
